// extracted by mini-css-extract-plugin
export default {"item":"PaginationItem_item__vlt35","itemActive":"PaginationItem_itemActive__Ekug0"};